/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GarantieCommissionItemDto } from './GarantieCommissionItemDto';
import {
    GarantieCommissionItemDtoFromJSON,
    GarantieCommissionItemDtoFromJSONTyped,
    GarantieCommissionItemDtoToJSON,
    GarantieCommissionItemDtoToJSONTyped,
} from './GarantieCommissionItemDto';

/**
 * Commissions rattachées à une garantie du tunnel.
 * @export
 * @interface GetGarantieCommissionsResponse
 */
export interface GetGarantieCommissionsResponse {
    /**
     * 
     * @type {Array<GarantieCommissionItemDto>}
     * @memberof GetGarantieCommissionsResponse
     */
    commissions?: Array<GarantieCommissionItemDto>;
}

/**
 * Check if a given object implements the GetGarantieCommissionsResponse interface.
 */
export function instanceOfGetGarantieCommissionsResponse(value: object): value is GetGarantieCommissionsResponse {
    return true;
}

export function GetGarantieCommissionsResponseFromJSON(json: any): GetGarantieCommissionsResponse {
    return GetGarantieCommissionsResponseFromJSONTyped(json, false);
}

export function GetGarantieCommissionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetGarantieCommissionsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'commissions': json['commissions'] == null ? undefined : ((json['commissions'] as Array<any>).map(GarantieCommissionItemDtoFromJSON)),
    };
}

export function GetGarantieCommissionsResponseToJSON(json: any): GetGarantieCommissionsResponse {
    return GetGarantieCommissionsResponseToJSONTyped(json, false);
}

export function GetGarantieCommissionsResponseToJSONTyped(value?: GetGarantieCommissionsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'commissions': value['commissions'] == null ? undefined : ((value['commissions'] as Array<any>).map(GarantieCommissionItemDtoToJSON)),
    };
}

